function isValidUrl (str) {
  // eslint-disable-next-line prefer-regex-literals
  const pattern = new RegExp('^https?://(www.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}.?[a-zA-Z0-9()]{1,6}([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)');
  return !!pattern.test(str);
}
export default isValidUrl;
